import * as i0 from '@angular/core';
import { Pipe, EventEmitter, Component, Inject, Input, Output, NgModule } from '@angular/core';
import * as i3 from '@angular/forms';
import { FormGroup, FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as i2 from '@angular/common';
import { DOCUMENT, CommonModule } from '@angular/common';
function NgOtpInputComponent_div_0_input_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 4, 0);
    i0.ɵɵlistener("paste", function NgOtpInputComponent_div_0_input_1_Template_input_paste_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.handlePaste($event));
    })("keyup", function NgOtpInputComponent_div_0_input_1_Template_input_keyup_0_listener($event) {
      const i_r3 = i0.ɵɵrestoreView(_r1).index;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onKeyUp($event, i_r3));
    })("input", function NgOtpInputComponent_div_0_input_1_Template_input_input_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onInput($event));
    })("keydown", function NgOtpInputComponent_div_0_input_1_Template_input_keydown_0_listener($event) {
      const i_r3 = i0.ɵɵrestoreView(_r1).index;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onKeyDown($event, i_r3));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r4 = ctx.$implicit;
    const i_r3 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMapInterpolate1("otp-input ", ctx_r1.config.inputClass, "");
    i0.ɵɵproperty("pattern", ctx_r1.config.allowNumbersOnly ? "\\d*" : "")("type", ctx_r1.inputType)("placeholder", (ctx_r1.config == null ? null : ctx_r1.config.placeholder) || "")("ngStyle", ctx_r1.config.inputStyles)("formControl", ctx_r1.otpForm.controls[item_r4])("id", ctx_r1.getBoxId(i_r3));
  }
}
function NgOtpInputComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵtemplate(1, NgOtpInputComponent_div_0_input_1_Template, 2, 9, "input", 3);
    i0.ɵɵpipe(2, "keys");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate1("ng-otp-input-wrapper wrapper ", ctx_r1.config.containerClass, "");
    i0.ɵɵpropertyInterpolate1("id", "c_", ctx_r1.componentKey, "");
    i0.ɵɵproperty("ngStyle", ctx_r1.config.containerStyles);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(2, 7, ctx_r1.otpForm == null ? null : ctx_r1.otpForm.controls));
  }
}
class KeyboardUtil {
  static ifTab(event) {
    return this.ifKey(event, 'Tab');
  }
  static ifDelete(event) {
    return this.ifKey(event, 'Delete;Del');
  }
  static ifBackspace(event) {
    return this.ifKey(event, 'Backspace');
  }
  static ifRightArrow(event) {
    return this.ifKey(event, 'ArrowRight;Right');
  }
  static ifLeftArrow(event) {
    return this.ifKey(event, 'ArrowLeft;Left');
  }
  static ifSpacebar(event) {
    return this.ifKey(event, 'Spacebar; '); //don't remove the space after ; as this will check for space key
  }
  static ifKey(event, keys) {
    let keysToCheck = keys.split(';');
    return keysToCheck.some(k => k === event.key);
  }
}
let KeysPipe = /*#__PURE__*/(() => {
  class KeysPipe {
    transform(value) {
      return Object.keys(value);
    }
  }
  /** @nocollapse */
  /** @nocollapse */KeysPipe.ɵfac = function KeysPipe_Factory(t) {
    return new (t || KeysPipe)();
  };
  KeysPipe.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
    name: "keys",
    type: KeysPipe,
    pure: true
  });
  return KeysPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NgOtpInputComponent = /*#__PURE__*/(() => {
  class NgOtpInputComponent {
    constructor(keysPipe, document) {
      this.keysPipe = keysPipe;
      this.document = document;
      this.config = {
        length: 4
      };
      // tslint:disable-next-line: no-output-on-prefix
      this.onInputChange = new EventEmitter();
      this.inputControls = new Array(this.config.length);
      this.componentKey = Math.random().toString(36).substring(2) + new Date().getTime().toString(36);
    }
    get inputType() {
      return this.config?.isPasswordInput ? 'password' : this.config?.allowNumbersOnly ? 'tel' : 'text';
    }
    ngOnInit() {
      this.otpForm = new FormGroup({});
      for (let index = 0; index < this.config.length; index++) {
        this.otpForm.addControl(this.getControlName(index), new FormControl());
      }
      this.otpForm.valueChanges.subscribe(v => {
        this.keysPipe.transform(this.otpForm.controls).forEach(k => {
          var val = this.otpForm.controls[k].value;
          if (val && val.length > 1) {
            if (val.length >= this.config.length) {
              this.setValue(val);
            } else {
              this.rebuildValue();
            }
          }
        });
      });
    }
    ngAfterViewInit() {
      if (!this.config.disableAutoFocus) {
        const containerItem = this.document.getElementById(`c_${this.componentKey}`);
        if (containerItem) {
          const ele = containerItem.getElementsByClassName('otp-input')[0];
          if (ele && ele.focus) {
            ele.focus();
          }
        }
      }
    }
    getControlName(idx) {
      return `ctrl_${idx}`;
    }
    onKeyDown($event, inputIdx) {
      const prevInputId = this.getBoxId(inputIdx - 1);
      const currentInputId = this.getBoxId(inputIdx);
      if (KeyboardUtil.ifSpacebar($event)) {
        $event.preventDefault();
        return false;
      }
      if (KeyboardUtil.ifBackspace($event)) {
        if (!$event.target.value) {
          this.clearInput(prevInputId, inputIdx - 1);
          this.setSelected(prevInputId);
        } else {
          this.clearInput(currentInputId, inputIdx);
        }
        this.rebuildValue();
        return;
      }
    }
    onInput($event) {
      let newVal = this.currentVal ? `${this.currentVal}${$event.target.value}` : $event.target.value;
      if (this.config.allowNumbersOnly && !this.validateNumber(newVal)) {
        $event.target.value = '';
        $event.stopPropagation();
        $event.preventDefault();
        return;
      }
    }
    onKeyUp($event, inputIdx) {
      if (KeyboardUtil.ifTab($event)) {
        inputIdx -= 1;
      }
      const nextInputId = this.getBoxId(inputIdx + 1);
      const prevInputId = this.getBoxId(inputIdx - 1);
      const currentInputId = this.getBoxId(inputIdx);
      if (KeyboardUtil.ifRightArrow($event)) {
        $event.preventDefault();
        this.setSelected(nextInputId);
        return;
      }
      if (KeyboardUtil.ifLeftArrow($event)) {
        $event.preventDefault();
        this.setSelected(prevInputId);
        return;
      }
      if (KeyboardUtil.ifDelete($event)) {
        if (!$event.target.value) {
          this.clearInput(prevInputId, inputIdx - 1);
          this.setSelected(prevInputId);
        } else {
          this.clearInput(currentInputId, inputIdx);
        }
        this.rebuildValue();
        return;
      }
      if (!$event.target.value) {
        return;
      }
      if (this.ifValidKeyCode($event)) {
        this.setSelected(nextInputId);
      }
      this.rebuildValue();
    }
    validateNumber(val) {
      return val && /^[0-9]+$/.test(val);
    }
    getBoxId(idx) {
      return `otp_${idx}_${this.componentKey}`;
    }
    clearInput(eleId, inputIdx) {
      let ctrlName = this.getControlName(inputIdx);
      this.otpForm.controls[ctrlName]?.setValue(null);
      const ele = this.document.getElementById(eleId);
      if (ele && ele instanceof HTMLInputElement) {
        ele.value = null;
      }
    }
    setSelected(eleId) {
      this.focusTo(eleId);
      const ele = this.document.getElementById(eleId);
      if (ele && ele.setSelectionRange) {
        setTimeout(() => {
          ele.setSelectionRange(0, 1);
        }, 0);
      }
    }
    ifValidKeyCode(event) {
      const inp = event.key;
      const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
      return isMobile || /[a-zA-Z0-9-_]/.test(inp);
    }
    focusTo(eleId) {
      const ele = this.document.getElementById(eleId);
      if (ele) {
        ele.focus();
      }
    }
    // method to set component value
    setValue(value) {
      if (this.config.allowNumbersOnly && isNaN(value)) {
        return;
      }
      this.otpForm.reset();
      if (!value) {
        this.rebuildValue();
        return;
      }
      value = value.toString().replace(/\s/g, ''); // remove whitespace
      Array.from(value).forEach((c, idx) => {
        if (this.otpForm.get(this.getControlName(idx))) {
          this.otpForm.get(this.getControlName(idx)).setValue(c);
        }
      });
      if (!this.config.disableAutoFocus) {
        const containerItem = this.document.getElementById(`c_${this.componentKey}`);
        var indexOfElementToFocus = value.length < this.config.length ? value.length : this.config.length - 1;
        let ele = containerItem.getElementsByClassName('otp-input')[indexOfElementToFocus];
        if (ele && ele.focus) {
          ele.focus();
        }
      }
      this.rebuildValue();
    }
    rebuildValue() {
      let val = '';
      this.keysPipe.transform(this.otpForm.controls).forEach(k => {
        if (this.otpForm.controls[k].value) {
          let ctrlVal = this.otpForm.controls[k].value;
          let isLengthExceed = ctrlVal.length > 1;
          let isCaseTransformEnabled = !this.config.allowNumbersOnly && this.config.letterCase && (this.config.letterCase.toLocaleLowerCase() == 'upper' || this.config.letterCase.toLocaleLowerCase() == 'lower');
          ctrlVal = ctrlVal[0];
          let transformedVal = isCaseTransformEnabled ? this.config.letterCase.toLocaleLowerCase() == 'upper' ? ctrlVal.toUpperCase() : ctrlVal.toLowerCase() : ctrlVal;
          if (isCaseTransformEnabled && transformedVal == ctrlVal) {
            isCaseTransformEnabled = false;
          } else {
            ctrlVal = transformedVal;
          }
          val += ctrlVal;
          if (isLengthExceed || isCaseTransformEnabled) {
            this.otpForm.controls[k].setValue(ctrlVal);
          }
        }
      });
      if (this.formCtrl?.setValue) {
        this.formCtrl.setValue(val);
      }
      this.onInputChange.emit(val);
      this.currentVal = val;
    }
    handlePaste(e) {
      // Get pasted data via clipboard API
      let clipboardData = e.clipboardData || window['clipboardData'];
      if (clipboardData) {
        var pastedData = clipboardData.getData('Text');
      }
      // Stop data actually being pasted into div
      e.stopPropagation();
      e.preventDefault();
      if (!pastedData || this.config.allowNumbersOnly && !this.validateNumber(pastedData)) {
        return;
      }
      this.setValue(pastedData);
    }
  }
  /** @nocollapse */
  /** @nocollapse */NgOtpInputComponent.ɵfac = function NgOtpInputComponent_Factory(t) {
    return new (t || NgOtpInputComponent)(i0.ɵɵdirectiveInject(KeysPipe), i0.ɵɵdirectiveInject(DOCUMENT));
  };
  NgOtpInputComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: NgOtpInputComponent,
    selectors: [["ng-otp-input"]],
    inputs: {
      config: "config",
      formCtrl: "formCtrl"
    },
    outputs: {
      onInputChange: "onInputChange"
    },
    decls: 1,
    vars: 1,
    consts: [["inp", ""], [3, "class", "id", "ngStyle", 4, "ngIf"], [3, "id", "ngStyle"], ["autocomplete", "one-time-code", 3, "pattern", "type", "placeholder", "ngStyle", "class", "formControl", "id", "paste", "keyup", "input", "keydown", 4, "ngFor", "ngForOf"], ["autocomplete", "one-time-code", 3, "paste", "keyup", "input", "keydown", "pattern", "type", "placeholder", "ngStyle", "formControl", "id"]],
    template: function NgOtpInputComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵtemplate(0, NgOtpInputComponent_div_0_Template, 3, 9, "div", 1);
      }
      if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.otpForm == null ? null : ctx.otpForm.controls);
      }
    },
    dependencies: [i2.NgIf, i2.NgStyle, i2.NgForOf, i3.DefaultValueAccessor, i3.PatternValidator, i3.NgControlStatus, i3.FormControlDirective, KeysPipe],
    styles: [".otp-input[_ngcontent-%COMP%]{width:50px;height:50px;border-radius:4px;border:solid 1px #c5c5c5;text-align:center;font-size:32px}.ng-otp-input-wrapper[_ngcontent-%COMP%]   .otp-input[_ngcontent-%COMP%]:not(:last-child){margin-right:8px}@media screen and (max-width: 767px){.otp-input[_ngcontent-%COMP%]{width:40px;font-size:24px;height:40px}}@media screen and (max-width: 420px){.otp-input[_ngcontent-%COMP%]{width:30px;font-size:18px;height:30px}}"]
  });
  return NgOtpInputComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NgOtpInputModule = /*#__PURE__*/(() => {
  class NgOtpInputModule {}
  /** @nocollapse */
  /** @nocollapse */

  /** @nocollapse */NgOtpInputModule.ɵfac = function NgOtpInputModule_Factory(t) {
    return new (t || NgOtpInputModule)();
  };
  NgOtpInputModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: NgOtpInputModule
  });
  NgOtpInputModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    providers: [KeysPipe],
    imports: [[CommonModule, FormsModule, ReactiveFormsModule]]
  });
  return NgOtpInputModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class Config {}

/*
 * Public API Surface of ng-otp-input
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NgOtpInputComponent, Config as NgOtpInputConfig, NgOtpInputModule };
